
import info from "./info"
export default  {
    namespaced:true,
    modules:{
        info,
    }
}